import store from '../store/'

export default [{
    path: '/makeaclaim',
    name: 'makeaclaim',
    components: { main: () => import(/* webpackChunkName: "makeaclaim" */ '../views/MakeAClaim.vue') },
    meta: {
      checkForUser: true
    },
    redirect: '/makeaclaim/1',
    children: [
      {
        path: '/makeaclaim/1',
        name: 'policylookup',
        beforeEnter (to, from, next) {    
          store.dispatch('resetBeforeMakeAClaim')
          next(next)
        },
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/tigaForm/PolicyLookup.vue') }
      },
      {
        path: '/makeaclaim/2',
        name: 'policydetails',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/tigaForm/PolicyDetails.vue') }
      },
    //   {
    //     path: '/makeaclaim/3',
    //     name: 'confirmemail',
    //     components: { makeaclaim: () => import(/* webpackChunkName: "form" */ './views/tigaForm/ConfirmContact.vue') }
    //   },
      {
        path: '/makeaclaim/5',
        name: 'incidenttypes',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/tigaForm/IncidentTypes.v2.vue') }
      },
      {
        path: '/makeaclaim/6',
        name: 'aboutYou',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/tigaForm/AboutYou.vue') }
      },
      {
        path: '/makeaclaim/8',
        name: 'incidentDetails',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/tigaForm/IncidentDetails.v2.vue') }
      },
      {
        path: '/makeaclaim/10',
        name: 'gadgetlist',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/tigaForm/gadgets/GadgetList.vue') }
      },
      {
        path: '/makeaclaim/101/:id?',
        name: 'gadgetDetails',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/tigaForm/gadgets/GadgetDetails.vue') }
      },
      {
        path: '/makeaclaim/11',
        name: 'supportingDocs',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/tigaForm/SupportingDocs.vue') }
      },
      {
        path: '/makeaclaim/13',
        name: 'declartion',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/tigaForm/Declaration.v2.vue') }
      },
      {
        path: '/makeaclaim/17',
        name: 'reviewv2',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/tigaForm/Review.v2.vue') }
      },
      {
        path: '/makeaclaim/thankyou',
        name: 'thankyou',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/tigaForm/ThankYou.v2.vue') }
      },
      {
        path: '/makeaclaim/approved',
        name: 'approved',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/tigaForm/ApprovedFastTrack.vue') }
      },
      {
        path: '/makeaclaim/resume',
        name: 'resume',
        components: { makeaclaim: () => import(/* webpackChunkName: "form" */ '../views/tigaForm/SavedFormLookup.vue') }
      }
    ]
  },
  {
    path: '/claimsguide',
    name: 'claimsguide',
    components: { main: () => import(/* webpackChunkName: "terms" */ '../views/guide/ClaimsGuideTiga.vue') }
  }]